/**
 * ChildNode.prepend() polyfill
 * Adapted from https://github.com/jserz/js_piece/blob/master/DOM/ParentNode/prepend()/prepend().md
 * @author Chris Ferdinandi
 * @license MIT
 */
(function (elem) {
    // Check if element is a node
    // https://github.com/Financial-Times/polyfill-service
    const isNode = function (object) {
        // DOM, Level2
        if (typeof Node === 'function') {
            return object instanceof Node;
        }

        // Older browsers, check if it looks like a Node instance)
        return object && typeof object === 'object' && object.nodeName && object.nodeType >= 1 && object.nodeType <= 12;
    };

    // Add append() method to prototype
    for (let i = 0; i < elem.length; i += 1) {
        if (!window[elem[i]] || 'prepend' in window[elem[i]].prototype) continue;
        window[elem[i]].prototype.prepend = function () {
            const argArr = Array.prototype.slice.call(arguments);
            const docFrag = document.createDocumentFragment();

            for (let n = 0; n < argArr.length; n += 1) {
                docFrag.appendChild(isNode(argArr[n]) ? argArr[n] : document.createTextNode(String(argArr[n])));
            }

            this.appendChild(docFrag);
        };
    }
}(['Element', 'CharacterData', 'DocumentType']));
